module.exports = __webpack_public_path__ + "img/新闻资讯_08.e3eb631b.png";